import {
  CLOSE_MENU, OPEN_MENU, SET_USER_NAME,
} from './actionTypes';

export const initialState = {
  isVisible: false,
  userName: '',
};

export const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MENU: return { ...state, isVisible: true };
    case CLOSE_MENU: return { ...state, isVisible: false };
    case SET_USER_NAME: return { ...state, userName: action.payload };
    default: return state;
  }
};
